import Vue from "vue";
import App from "./App.vue";

//Register components hooks before Vuelidate
import "@/plugins/registerComponentHooks";
import Vuelidate from "vuelidate";

import router from "./router";
import store from "./store";

import "@/plugins/localforage";
import "@/plugins/prism";
import "@/plugins/notifications";
import "@/plugins/select";
import "@/plugins/waypoint";
import "@/plugins/mixpanel";
import "@/plugins/recaptcha";

import "@/assets/css/tailwind.css";
Vue.config.productionTip = false;

Vue.use(Vuelidate);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
